import React from 'react';
import { Section } from '../ui/Section';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function Mechanism() {
  return <Section background="white" className="text-center" data-id="element-222">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} viewport={{
      once: true
    }} className="max-w-3xl mx-auto" data-id="element-223">
        <div className="bg-cream rounded-[3rem] border border-dusty-rose/20 shadow-sm p-10 md:p-16" data-id="element-224">
          <h2 className="text-3xl md:text-5xl font-serif italic text-warm-gold mb-8" data-id="element-225">
            Método Energía Real
          </h2>

          <div className="space-y-4 text-lg md:text-xl text-navy font-light mb-10 leading-relaxed" data-id="element-226">
            <p data-id="element-227">Esto no es motivación ni productividad.</p>
            <p data-id="element-228">
              Es un método guiado para detectar y cerrar las fugas de energía
              invisibles que te agotan cada día.
            </p>
          </div>

          <div className="flex flex-col md:flex-row justify-center gap-6 md:gap-10" data-id="element-229">
            {['Todo amable', 'Todo aplicable', 'Todo pensado para vida real'].map((item, i) => <div key={i} className="flex items-center justify-center gap-3" data-id="element-230">
                <div className="bg-warm-gold/10 p-1.5 rounded-full" data-id="element-231">
                  <Check className="w-5 h-5 text-warm-gold" data-id="element-232" />
                </div>
                <span className="font-medium text-navy/80" data-id="element-233">{item}</span>
              </div>)}
          </div>
        </div>
      </motion.div>
    </Section>;
}